import d1 from './Data/d1';
import dataStrategyExecution from './Data/DataStrategyExecution';
import dataStrategyExecution2 from './Data/DataStrategyExecution2';
import dataProgression from './Data/DataProgression';
import d2 from './Data/d2';
import data4 from './Data/data4';
import dataUnderval from './Data/dataUnderval';
import dataMethodologies from './Data/dataMethodologies';
import dataInfluences from './Data/dataInfluences';
import dataValuationRetained from './Data/dataValuationRetained';
import dataStrength from './Data/dataStrength';
import dataWeakness from './Data/dataWeakness';
import dataPeerInvest from './Data/dataPeerInvest';
import dataFeedback from './Data/dataFeedback';
import dataValuationMethodo from './Data/dataValuationMethodo';
import dataCapitalStructure from './Data/dataCapitalStructure';
import dataOrderBook from './Data/dataOrderBook';
import dataAllocation from './Data/dataAllocation';
import dataImpliedWacc from './Data/dataImpliedWacc';
import dataDispersion from './Data/dataDispersion';

const getData = (dataName) => {
  const dataList = {
    d1,
    dataStrategyExecution,
    dataStrategyExecution2,
    d2,
    dataProgression,
    data4,
    dataUnderval,
    dataMethodologies,
    dataInfluences,
    dataValuationRetained,
    dataStrength,
    dataWeakness,
    dataPeerInvest,
    dataFeedback,
    dataValuationMethodo,
    dataCapitalStructure,
    dataOrderBook,
    dataAllocation,
    dataImpliedWacc,
    dataDispersion
  };
  const foundData = dataList[dataName];

  if (!foundData) {
    throw new Error('Data not found !');
  }
  return foundData;
};

export const fetchData = async (
  dataSet = 'dataProgression',
  shouldResolve = true,
  fetchDuration = 500
) => {
  return new Promise((resolve, reject) => {
    setTimeout(function () {
      if (shouldResolve) {
        resolve(getData(dataSet));
      } else {
        reject('Error 500 : please contact JD! :)');
      }
    }, fetchDuration);
  });
};
